import TitleList from './collections/title'
import config from './config'
import { loadModel } from './overrides'

const titles = new TitleList()

titles.load = function() {
    this.reset(config.get('titles') || [])

    const questionData = config.get('questionData')
    if (questionData && questionData.quiz_list) {
        this.each(title => {
            const titleName = title.get('name')
            const questionsForTitle = questionData.quiz_list.find(q => q.text === titleName)

            if (questionsForTitle) {
                const TestModel = loadModel('test')
                title.set({
                    test: new TestModel(),
                    question_list: questionsForTitle.scenario_list,
                    test_available: true
                }, { silent: true })
            } else {
                title.set({ test_available: false }, { silent: true })
            }
        })
    }

    // Mark first 5 free, again silently
    this.first(5).forEach((title) => {
        title.set('free', true, { silent: true })
    })

    // Now do ONE manual "update" or "change" event
    // so the HomeView can re-render once
    this.trigger('update', this)

    // Check if at least one title has a question list
    const hasQuestions = this.some(t => {
        const list = t.get('question_list')
        return list && list.length > 0
    })

    config.set('testAvailable', hasQuestions)
}

export default titles